module.exports = __webpack_public_path__ + "static/media/twitter.42548f99.svg";